import { css } from "@emotion/css";
import * as React from "react";
import { UserChip } from "~/components/Chips/UserChip";
import { ChipIcon, TeamChip } from "~/components/Chips/index";
import { isFeatureToggleEnabled } from "~/components/FeatureToggle/New/FeatureToggleContext";
import LookupResourceChip from "~/components/LookupResourceChip/index";
import InternalLink from "~/components/Navigation/InternalLink/index";
import Tag from "~/components/Tag/index";
import { DataTable, DataTableBody, DataTableHeader, DataTableHeaderColumn, DataTableRow, DataTableRowColumn } from "~/primitiveComponents/dataDisplay/DataTable/index";
import type { GetTeamsLookupBffResponseTeam, TagSetResource, UserResource } from "../../../../../../../packages/octopus-server-client/src/index";
import type { ApprovalPolicyResource } from "../../../../../../../packages/octopus-server-client/src/resources/approvalPolicies/approvalPolicyResource";
import { links } from "../../../../../../../packages/portal-routes/src/index";
interface ApprovalPolicyTableProps {
    approvalPolicies: ApprovalPolicyResource[];
    projectTagSets: TagSetResource[];
    environmentTagSets: TagSetResource[];
    teamsLookup: GetTeamsLookupBffResponseTeam[];
    usersLookup: UserResource[];
}
export function ApprovalPolicyTable({ approvalPolicies, teamsLookup, usersLookup, projectTagSets, environmentTagSets }: ApprovalPolicyTableProps) {
    const LookupTeamChip = LookupResourceChip<GetTeamsLookupBffResponseTeam>();
    const projectTagsLookup = projectTagSets.flatMap((tagSet) => tagSet.Tags);
    const environmentTagsLookup = environmentTagSets.flatMap((tagSet) => tagSet.Tags);
    return (<DataTable>
            <DataTableHeader>
                <DataTableRow>
                    <DataTableHeaderColumn width={"30%"} aria-label={"Name column"}>
                        Name
                    </DataTableHeaderColumn>
                    <DataTableHeaderColumn aria-label={"Approvers column"}>Approvers</DataTableHeaderColumn>
                    <DataTableHeaderColumn aria-label={"Project Tags column"}>Project Tags</DataTableHeaderColumn>
                    <DataTableHeaderColumn aria-label={"Environment Tags column"}>Environment Tags</DataTableHeaderColumn>
                </DataTableRow>
            </DataTableHeader>
            <DataTableBody>
                {approvalPolicies.map((policy) => (<DataTableRow key={policy.Id}>
                        <DataTableRowColumn className={styles.nameColumn}>
                            <InternalLink to={links.approvalPolicyPage.generateUrl({ spaceId: policy.SpaceId, id: policy.Id })}>{policy.Name}</InternalLink>
                        </DataTableRowColumn>
                        <DataTableRowColumn>
                            {policy.ApprovingTeamIds && policy.ApprovingTeamIds.map((team) => <LookupTeamChip lookupCollection={teamsLookup} key={team} lookupId={team} type={ChipIcon.Team} chipRender={(t) => <TeamChip team={t}/>}/>)}
                            {policy.ApprovingUserIds &&
                policy.ApprovingUserIds.map((user) => {
                    const userInfo = usersLookup.find((u) => u.Id === user);
                    return userInfo && <UserChip user={userInfo}></UserChip>;
                })}
                        </DataTableRowColumn>
                        <DataTableRowColumn>
                            <div>
                                {isFeatureToggleEnabled("extended-tag-sets") &&
                policy.ProjectTags &&
                policy.ProjectTags.map((tag) => {
                    const tagInfo = projectTagsLookup.find((t) => t.CanonicalTagName === tag);
                    return tagInfo && <Tag key={tag} tagName={tagInfo.CanonicalTagName} description={tagInfo.Description} tagColor={tagInfo.Color} small={false}/>;
                })}
                            </div>
                        </DataTableRowColumn>
                        <DataTableRowColumn>
                            <div>
                                {isFeatureToggleEnabled("extended-tag-sets") &&
                policy.EnvironmentTags &&
                policy.EnvironmentTags.map((tag) => {
                    const tagInfo = environmentTagsLookup.find((t) => t.CanonicalTagName === tag);
                    return tagInfo && <Tag key={tag} tagName={tagInfo.CanonicalTagName} description={tagInfo.Description} tagColor={tagInfo.Color} small={false}/>;
                })}
                            </div>
                        </DataTableRowColumn>
                    </DataTableRow>))}
            </DataTableBody>
        </DataTable>);
}
const styles = {
    nameColumn: css({
        wordWrap: "break-word",
    }),
};
